import React from 'react'
import Loading from '../../pages/Loading'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { getSonePersonalDetails, getCoursesSummary } from '../../../services/vu'
import Error from '../../pages/Error'
import { receivePersonalDetails } from '../../../actions/personalDetails'
import { storeCourseCode, receiveCourses } from '../../../actions/courses'
import { setCourseIdViaQueryParameter } from '../../../helpers/course'

const mapStateToProps = ({ currentUser }) => {
  return {
    currentUser: currentUser
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setPersonalDetails: personalDetails => {
      dispatch(receivePersonalDetails(personalDetails))
    },
    storeCourseCode: courseCode => {
      dispatch(storeCourseCode(courseCode))
    },
    setCourses: courses => {
      dispatch(receiveCourses(courses))
    }
  }
}

class ParallelLoad extends React.Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      loading: true,
      failedToRetrievePersonalDetails: false,
      failedToRetrieveCourses: false
    }
  }

  getSelectedCourseId = () => {
    return setCourseIdViaQueryParameter(this.props.location.search)
  }

  componentDidMount() {
    if (this.state.loading) {
      const courseCode = this.getSelectedCourseId()
      this.props.storeCourseCode(courseCode);
      let queryParams = {}
      queryParams["spkCode"] = courseCode

      this.getPassedInYearParameter()

      Promise.all([getSonePersonalDetails(), getCoursesSummary(queryParams)])
        .then(([personalDetails, coursesSummary]) => {
          this.props.setPersonalDetails(personalDetails)
          this.props.setCourses(coursesSummary)
          this.setState({
            loading: false
          })
        })
        .catch(error => {
          this.setState({
            loading: false,
            failedToRetrievePersonalDetails: error.response.config.url === '/api/student/personalData',
            failedToRetrieveCourses: error.response.config.url === '/api/student/courses',
            failedToRetrieveCoursesSummary: error.response.config.url === '/api/courses/summary'
          })
        })
    }
  }

  getPassedInYearParameter = () => {
    let urlPath = this.props.location.pathname;
    let pathsegments = urlPath.split('/').filter(segment => segment !== '');
    let year = 0;
    
    if (pathsegments.length > 2 && pathsegments[0] === "manage" && pathsegments[1] === "units") {
      if (pathsegments.length  === 3) {
        year = pathsegments[2].trim()
      } else {
        const queryParams = qs.parse(searchLocation, {
          ignoreQueryPrefix: true
        })
        const yearProperty = Object.keys(queryParams).find(
          queryParam => queryParam.toLocaleLowerCase() === 'defaultyear'
        )
        if (yearProperty && queryParams.hasOwnProperty(yearProperty)) {
          year = queryParams[yearProperty]
        }
      }

      if (year !== null && year !== undefined && year !== 0) {
        sessionStorage.setItem("DEFAULT_YEAR", year.trim());
      }
    }
  }

  render() {
    if (this.state.failedToRetrievePersonalDetails) {
      return (
        <Error
          title="ERROR"
          description={<p>System is down.</p>}
          longDescription={
            <span>
              For assistance, please contact{' '}
              <a href="https://www.vu.edu.au/contact-us/vuhq-student-service-centres">
                VUHQ
              </a>
              ‌.
            </span>
          }
        />
      )
    }

    if (this.state.failedToRetrieveCourses || this.state.failedToRetrieveCoursesSummary) {
      return (
        <Error
          title="ERROR"
          description={<p>System is down.</p>}
          longDescription={
            <span>
              For assistance, please contact{' '}
              <a href="https://www.vu.edu.au/contact-us/vuhq-student-service-centres">
                VUHQ
              </a>
              ‌.
            </span>
          }
        />
      )
    }

    if (this.state.loading) {
      return <Loading />
    }

    return this.props.children
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ParallelLoad)
)
